import {ColorGradientRestDto, ColorSolidRestDto} from "@/api/pharma-cms-content-page/models";
import {ColorSolidRestDtoModel} from "@/models/api/ColorSolidRestDtoModel";
import {DirectionEnum} from "@/api/enums/direction-enum";

export class ColorGradientRestDtoModel implements ColorGradientRestDto {
    direction_code: DirectionEnum;
    start: ColorSolidRestDto;
    end: ColorSolidRestDto;

    constructor(
        direction_code: DirectionEnum,
        start: ColorSolidRestDto,
        end: ColorSolidRestDto
    ) {
        this.direction_code = direction_code;
        this.start = start;
        this.end = end;
    }

    static createWithDefaults(): ColorGradientRestDtoModel {
        return new this(
            DirectionEnum.TO_BOTTOM,
            ColorSolidRestDtoModel.createWithDefaults(),
            ColorSolidRestDtoModel.createWithDefaults()
        );
    }

    static cloneFrom(source: ColorGradientRestDto): ColorGradientRestDtoModel {
        return new this(
            source.direction_code,
            ColorSolidRestDtoModel.cloneFrom(source.start),
            ColorSolidRestDtoModel.cloneFrom(source.end)
        );
    }
}
